"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeBoxHandle = exports.ResizeBox = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const react_resizable_1 = require("react-resizable");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.ResizeBox = (0, styled_components_1.default)(react_resizable_1.ResizableBox).attrs({
    style: { maxWidth: '100%' }
}) `
  border-color: ${({ $hasError }) => {
    if ($hasError)
        return (0, wl_ui_kit_1.getColorShade)('danger', 'highEmphasis');
    return (0, wl_ui_kit_1.getColorShade)('onSurface', 'outline');
}};
  border-style: solid;
  border-width: 1px;
  border-radius: ${(0, wl_ui_kit_1.getThemeProp)('borderRadius')}px;

  &:hover {
    border-color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'lowEmphasis')};
  }

  &:focus-within {
    border: 1px solid ${(0, wl_ui_kit_1.getColor)('primary')};
    outline: none;
  }
`;
exports.ResizeBoxHandle = styled_components_1.default.span `
  position: absolute;
  right: 0;
  bottom: 0;
  width: 9px;
  height: 9px;
  background-image: linear-gradient(
    -45deg,
    ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'lowEmphasis')} 50%,
    ${(0, wl_ui_kit_1.getColor)('surface')} 50%
  );
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 9px 9px;
  border-radius: 0 0 ${(0, wl_ui_kit_1.getSizeBy)()} 0;
  box-shadow: inset -1px -1px ${(0, wl_ui_kit_1.getColor)('surface')};
  cursor: s-resize;
`;
//# sourceMappingURL=styled.js.map